import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hr-info-dashboard',
  templateUrl: './hr-info-dashboard.component.html',
  styleUrls: ['./hr-info-dashboard.component.css']
})
export class HrInfoDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
